export default function Footer() {
  const quickLinks = [
    { label: '精彩专题', href: '#index' },
    { label: '热播榜单', href: '#ranking' },
    { label: '精彩预告', href: '#media' },
    { label: '最新动态', href: '#updates' },
    { label: '常见问题', href: '#faq' },
    { label: '精选推荐', href: '#cards' },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-500 text-xl"></i>
              </div>
              <span className="text-foreground-50 font-heading font-bold text-lg">
                天美麻花星空影视
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              天美麻花星空影视免费观看电视平台，提供超清蓝光电视剧全集、电影大全、综艺动漫免费在线观看。支持大屏TV版多端同步，不缓冲流畅播放，每日更新热门影视资源。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-100 font-heading font-bold text-sm mb-4">快速导航</h4>
            <ul className="space-y-2">
              {quickLinks.slice(0, 3).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 font-heading font-bold text-sm mb-4">更多内容</h4>
            <ul className="space-y-2">
              {quickLinks.slice(3).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 font-heading font-bold text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-600 italic">
              优质内容合作方持续接入中
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            天美麻花星空影视 © 2026 版权所有 | 免费高清在线影视平台
          </p>
          <p className="text-xs text-foreground-700">
            所有内容均来自互联网公开资源，仅供交流学习
          </p>
        </div>
      </div>
    </footer>
  );
}